import { types } from "../action-types";

const initialState = {
  loading: false,
  details: {},
  error: false,
  test: false,
  fav_status: false,
  isFav:false,
};

const favoritesReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_MESSAGE_FAVOURITE_REQUESTED:
      return {
        ...state,
        loading: true,
        fav_status: false
      };

    case types.GET_MESSAGE_FAVOURITE_SUCCESS:
      return {
        ...state,
        loading: false,
        details: action.payload,
        error: false,
        test: !state.test,
        isFav: true,
        fav_status:"added"
    };
    case types.GET_MESSAGE_FAVOURITE_FAILURE:
      return {
        ...state,
        loading: false,
        // details: {},
        error: true,
      };
    case types.REMOVE_MESSAGE_FAVOURITE_INTI:
      return {
        ...state,
        loading: true,
        fav_status: false
      };

    case types.REMOVE_MESSAGE_FAVOURITE_SUCCESS:
      return {
        ...state,
        loading: true,
        // details: action.payload,
        error: false,
        fav_status:"removed"
      
      };
    case types.REMOVE_MESSAGE_FAVOURITE_FAILURE:
      return {
        ...state,
        loading: false,
        // details: [],
        error: true,
      };
      case types.MESSAGE_FAVOURITE_RESET:
        return {
          ...state,
       fav_status: false,
      isFav: false,
       loading:false
        };
    default:
      return state;
  }
};


export default favoritesReducer;
